/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /**
   * Press Reviews Carousel Component
   * Converts grid layout to carousel using Flickity when blocks exceed blocks_per_row
   */
  if (!customElements.get('press-reviews-carousel')) {
    customElements.define(
      'press-reviews-carousel',
      class PressReviewsCarousel extends HTMLElement {
        constructor() {
          super();
          this.reviewsContainer = null;
          this.blocksPerRowLarge = parseFloat(this.dataset.blocksPerRowLarge || 2.5);
          this.blocksPerRowMedium = parseFloat(this.dataset.blocksPerRowMedium || 2.2);
          this.blocksPerRowSmall = parseFloat(this.dataset.blocksPerRowSmall || 1.2);
          this.totalBlocks = parseInt(this.dataset.totalBlocks || 0, 10);
          this.flkty = null;
          this.isMobile = false;
          this.handleResize = this.handleResize.bind(this);
        }

        connectedCallback() {
          this.init();
          document.addEventListener('theme:resize:width', this.handleResize);
        }

        handleResize() {
          this.init();
        }

        getBlocksPerRow() {
          // Responsive breakpoints matching CSS
          const screenWidth = window.innerWidth;
          
          if (screenWidth >= 1200) {
            return this.blocksPerRowLarge;
          } else if (screenWidth >= 500) {
            return this.blocksPerRowMedium;
          } else {
            return this.blocksPerRowSmall;
          }
        }

        init() {
          this.reviewsContainer = this.querySelector('.section-press-reviews__reviews');
          
          if (!this.reviewsContainer) return;

          const currentBlocksPerRow = this.getBlocksPerRow();
          
          // Update CSS variable for responsive grid
          // this.style.setProperty('--blocks-per-row', currentBlocksPerRow);

          // Check if we need carousel mode
          const shouldBeCarousel = this.totalBlocks > currentBlocksPerRow;

          if (shouldBeCarousel) {
            this.enableCarousel();
          } else {
            this.disableCarousel();
          }
        }

        enableCarousel() {
          this.reviewsContainer.classList.add('is-carousel');
          
          // Initialize Flickity if not already initialized
          if (!this.flkty) {
            this.initializeFlickity();
          }
        }

        disableCarousel() {
          this.reviewsContainer.classList.remove('is-carousel');
          
          // Destroy Flickity if it exists
          if (this.flkty) {
            this.flkty.destroy();
            this.flkty = null;
            this.reviewsContainer.classList.remove('flickity-enabled');
          }
        }

        initializeFlickity() {
          const options = {
            cellAlign: 'left',
            contain: true,
            draggable: true,
            freeScroll: false,
            friction: 0.3,
            initialIndex: 0,
            pageDots: true,
            prevNextButtons: true,
            wrapAround: false,
          };

          // Use theme's Flickity class if available, otherwise use window.Flickity
          if (window.theme && window.theme.Flickity) {
            this.flkty = new window.theme.Flickity(this.reviewsContainer, options);
          } else if (window.Flickity) {
            this.flkty = new window.Flickity(this.reviewsContainer, options);
          } else {
            console.error('Flickity library is not loaded.');
          }
        }

        disconnectedCallback() {
          document.removeEventListener('theme:resize:width', this.handleResize);
          if (this.flkty) {
            this.flkty.destroy();
            this.flkty = null;
          }
        }
      }
    );
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
